import React, { useEffect, useState } from "react";
import {
  Button,
  Form,
  Col,
  Row,
  Tabs,
  Tab,
  ButtonToolbar,
  Modal,
} from "react-bootstrap";
import {
  Card,
  CardBody,
  CardHeader,
  CardHeaderToolbar,
  CardHeaderTitle,
} from "../../../_metronic/_partials/controls";
import { LayoutSplashScreen } from "../../../_metronic/layout";
import { useSelector, useDispatch } from "react-redux";
import { useHistory, useParams } from "react-router-dom";

import {
  formatDate,
  iconError,
  showConfirmDialog,
  showDeleteDialog,
  showDialog,
  showErrorDialog,
  showSuccessDialog,
} from "../../utility";
import BootstrapTable from "react-bootstrap-table-next";
import Select from "react-select";
import { fetchOffice, selectOffice } from "../office/officeSlice";
import { OverlayTrigger, Tooltip } from "react-bootstrap";
import { toAbsoluteUrl } from "../../../_metronic/_helpers";
import SVG from "react-inlinesvg";

import { makeStyles, fade } from "@material-ui/core/styles";
import TextField from "@material-ui/core/TextField";
import {
  fetchGroupCountry,
  fetchGroupPhoneType,
  fetchParameter,
  fetchParameter2,
  selectParameter,
  selectParameter2,
} from "../businessParameter/businessParameterSlice";
import {
  Checkbox,
  FormControlLabel,
  FormGroup,
  FormHelperText,
  MenuItem,
  Radio,
  RadioGroup,
} from "@material-ui/core";
import { Autocomplete } from "@material-ui/lab";
import { ModalOffice } from "../filterModal/ModalOffice";
import { ModalClient } from "../filterModal/ModalClient";

import {
  fetchMstaddresstype,
  selectMstaddresstype,
} from "../location/locationSlice";
import { fetchClient } from "../client/clientSlice";
import {
  editMasterUpload,
  fetchIdMasterUpload,
  selectIdMasterUpload,
  selectLoading,
} from "./MiscellaneousSlice";

const useStylesReddit = makeStyles((theme) => ({
  root: {
    border: "1px solid #e2e2e1",
    overflow: "hidden",
    borderRadius: 4,
    backgroundColor: "#FFFFFF",
    transition: theme.transitions.create(["border-color", "box-shadow"]),
    "&:hover": {
      backgroundColor: "#fff",
    },
    "&$focused": {
      backgroundColor: "#fff",
      boxShadow: `${fade(theme.palette.primary.main, 0.25)} 0 0 0 2px`,
      borderColor: theme.palette.primary.main,
    },
  },
  focused: {},
}));
function RedditTextField(props) {
  const classes = useStylesReddit();

  return (
    <TextField InputProps={{ classes, disableUnderline: true }} {...props} />
  );
}

const useStyles = makeStyles((theme) => ({
  root: {
    display: "flex",
    flexWrap: "wrap",
  },
  margin: {
    margin: theme.spacing(1),
  },
}));

export const MasterUploadEdit = () => {
  const classes = useStyles();
  const dispatch = useDispatch();
  const history = useHistory();
  const loading = useSelector(selectLoading);
  const dataId = useSelector(selectIdMasterUpload);

  const { id } = useParams();

  const [columnsType, setColumnsType] = useState("");

  // initial

  useEffect(() => {
    async function fetchMyAPI() {
      // Fetch data on first load
      await dispatch(fetchIdMasterUpload(id));
    }
    fetchMyAPI();
  }, [dispatch]);

  // useEffect(() => {
  //   if (dataId !== null) {
  //     if (dataId.file_type === "PARTY") {
  //       setColumnsType("columnsParty");
  //     }
  //     if (dataId.file_type === "LOCATION") {
  //       setColumnsType("columnsLocationMaster");
  //     }
  //     if (dataId.file_type === "PRODUCTMASTER") {
  //       setColumnsType("columnsProductMaster");
  //     }
  //     if (dataId.file_type === "MODELMASTER") {
  //       setColumnsType("columnsModelMaster");
  //     }
  //     if (dataId.file_type === "COLORMASTER") {
  //       setColumnsType("columnsColorMaster");
  //     }
  //     if (dataId.file_type === "COUNTRY") {
  //       setColumnsType("columnsCountry");
  //     }
  //   }
  // }, [dataId]);

  console.log(columnsType, "columnsType");

  // HanldeSave

  const handleSave = async () => {
    console.log(params, "params");
    const params = {
      misc_header_id: dataId.misc_header_id,
    };
    try {
      const response = await dispatch(editMasterUpload(params));

      if (response.payload.status === 200) {
        const action = await showSuccessDialog(response.payload.data.message);
        await window.location.reload();
      } else {
        await showErrorDialog(response.payload.data.message);
      }
    } catch (error) {
      showErrorDialog(error.message);
    }
  };

  const columnsLocationMaster = [
    {
      text: "Code",
      dataField: "locationmaster_code",

      style: { minWidth: "60px" },
      headerAlign: "center",
    },
    {
      text: "Name",
      dataField: "locationmaster_name",

      style: { minWidth: "60px" },
      headerAlign: "center",
    },
    {
      text: "Type",
      dataField: "locationmaster_type",

      style: { minWidth: "60px" },
      headerAlign: "center",
    },
    {
      text: "City",
      dataField: "locationmaster_city",

      style: { minWidth: "60px" },
      headerAlign: "center",
    },
    {
      text: "Country",
      dataField: "locationmaster_country_code",

      style: { minWidth: "60px" },
      headerAlign: "center",
    },
    {
      text: "Latitude",
      dataField: "locationmaster_latitude",

      style: { minWidth: "60px" },
      headerAlign: "center",
    },
    {
      text: "Longitude",
      dataField: "locationmaster_longitude",

      style: { minWidth: "60px" },
      headerAlign: "center",
    },
    {
      text: "UN Code",
      dataField: "locationmaster_uncode",

      style: { minWidth: "60px" },
      headerAlign: "center",
    },
    {
      text: "status",
      dataField: "status_validate",
      style: { minWidth: "60px" },
      headerAlign: "center",
    },
    {
      text: "Validate",
      dataField: "remark",
      style: { minWidth: "60px" },
      headerAlign: "center",
    },
  ];

  const columnsParty = [
    {
      text: "Code",
      dataField: "party_code",
      style: { minWidth: "60px" },
      headerAlign: "center",
    },
    {
      text: "Name",
      dataField: "party_name",
      style: { minWidth: "60px" },
      headerAlign: "center",
    },
    {
      text: "Description",
      dataField: "party_description",
      style: { minWidth: "60px" },
      headerAlign: "center",
    },

    {
      text: "Status",
      dataField: "status_validate",
      style: { minWidth: "60px" },
      headerAlign: "center",
    },
    {
      text: "Validate",
      dataField: "remark",
      style: { minWidth: "60px" },
      headerAlign: "center",
    },
  ];

  const columnsColorMaster = [
    {
      text: "Code",
      dataField: "colormaster_code",
      style: { minWidth: "60px" },
      headerAlign: "center",
    },
    {
      text: "Name",
      dataField: "colormaster_name",
      style: { minWidth: "60px" },
      headerAlign: "center",
    },
    {
      text: "Description",
      dataField: "colormaster_description",
      style: { minWidth: "60px" },
      headerAlign: "center",
    },

    {
      text: "Status",
      dataField: "status_validate",
      style: { minWidth: "60px" },
      headerAlign: "center",
    },
    {
      text: "Validate",
      dataField: "remark",
      style: { minWidth: "60px" },
      headerAlign: "center",
    },
  ];

  const columnsCountry = [
    {
      text: "Code",
      dataField: "country_code",
      style: { minWidth: "60px" },
      headerAlign: "center",
    },
    {
      text: "Name",
      dataField: "country_name",
      style: { minWidth: "60px" },
      headerAlign: "center",
    },
    {
      text: "Description",
      dataField: "colormaster_description",
      style: { minWidth: "60px" },
      headerAlign: "center",
    },
    {
      text: "UN Code",
      dataField: "un_code",
      style: { minWidth: "60px" },
      headerAlign: "center",
    },

    {
      text: "Status",
      dataField: "status_validate",
      style: { minWidth: "60px" },
      headerAlign: "center",
    },
    {
      text: "Validate",
      dataField: "remark",
      style: { minWidth: "60px" },
      headerAlign: "center",
    },
  ];

  const columnsModelMaster = [
    {
      text: "Code",
      dataField: "modelmaster_code",
      style: { minWidth: "60px" },
      headerAlign: "center",
    },
    {
      text: "Name",
      dataField: "modelmaster_name",
      style: { minWidth: "60px" },
      headerAlign: "center",
    },

    {
      text: "Status",
      dataField: "status_validate",
      style: { minWidth: "60px" },
      headerAlign: "center",
    },
    {
      text: "Validate",
      dataField: "remark",
      style: { minWidth: "60px" },
      headerAlign: "center",
    },
  ];

  const columnsProductMaster = [
    {
      text: "Code",
      dataField: "product_code",
      style: { minWidth: "60px" },
      headerAlign: "center",
    },
    {
      text: "Name",
      dataField: "product_name",
      style: { minWidth: "60px" },
      headerAlign: "center",
    },
    {
      text: "Color",
      dataField: "product_color",
      style: { minWidth: "60px" },
      headerAlign: "center",
    },

    {
      text: "Uom",
      dataField: "product_baseuom",
      style: { minWidth: "60px" },
      headerAlign: "center",
    },

    {
      text: "Heigth",
      dataField: "product_heigth",
      style: { minWidth: "60px" },
      headerAlign: "center",
    },
    {
      text: "Length",
      dataField: "product_length",
      style: { minWidth: "60px" },
      headerAlign: "center",
    },
    {
      text: "Width",
      dataField: "product_width",
      style: { minWidth: "60px" },
      headerAlign: "center",
    },

    {
      text: "Model",
      dataField: "product_model",
      style: { minWidth: "60px" },
      headerAlign: "center",
    },
    {
      text: "Netweight",
      dataField: "product_netweight",
      style: { minWidth: "60px" },
      headerAlign: "center",
    },
    {
      text: "Volume",
      dataField: "product_volume",
      style: { minWidth: "60px" },
      headerAlign: "center",
    },
    {
      text: "UOM",
      dataField: "product_volumetype",
      style: { minWidth: "60px" },
      headerAlign: "center",
    },
    {
      text: "Gross Weight",
      dataField: "product_grossweight",
      style: { minWidth: "60px" },
      headerAlign: "center",
    },
    {
      text: "UOM",
      dataField: "product_weighttype",
      style: { minWidth: "60px" },
      headerAlign: "center",
    },

    {
      text: "Status",
      dataField: "status_validate",
      style: { minWidth: "60px" },
      headerAlign: "center",
    },
    {
      text: "Validate",
      dataField: "remark",
      style: { minWidth: "60px" },
      headerAlign: "center",
    },
  ];

  const columnsLocation = [
    {
      text: "Code",
      dataField: "location_name",
      style: { minWidth: "60px" },
      headerAlign: "center",
    },
    {
      text: "Name",
      dataField: "location_name",
      style: { minWidth: "60px" },
      headerAlign: "center",
    },
    {
      text: "Area Type",
      dataField: "area_type",
      style: { minWidth: "60px" },
      headerAlign: "center",
    },
    {
      text: "Product",
      dataField: "storage_product",
      style: { minWidth: "60px" },
      headerAlign: "center",
    },
    {
      text: "Model",
      dataField: "storage_model",
      style: { minWidth: "60px" },
      headerAlign: "center",
    },
    {
      text: "Color",
      dataField: "storage_color",
      style: { minWidth: "60px" },
      headerAlign: "center",
    },
    {
      text: "Position X",
      dataField: "position_x",
      style: { minWidth: "60px" },
      headerAlign: "center",
    },
    {
      text: "Position Y",
      dataField: "position_y",
      style: { minWidth: "60px" },
      headerAlign: "center",
    },
    {
      text: "Position Z",
      dataField: "position_z",
      style: { minWidth: "60px" },
      headerAlign: "center",
    },
    {
      text: "Position UOM",
      dataField: "position_uom",
      style: { minWidth: "60px" },
      headerAlign: "center",
    },

    {
      text: "Dimension L",
      dataField: "dimension_l",
      style: { minWidth: "60px" },
      headerAlign: "center",
    },
    {
      text: "Dimension W",
      dataField: "dimension_w",
      style: { minWidth: "60px" },
      headerAlign: "center",
    },
    {
      text: "Dimension H",
      dataField: "dimension_h",
      style: { minWidth: "60px" },
      headerAlign: "center",
    },
    {
      text: " Dimension UOM",
      dataField: "dimension_uom",
      style: { minWidth: "60px" },
      headerAlign: "center",
    },
    {
      text: "Max Weight",
      dataField: "capacity_weight",
      style: { minWidth: "60px" },
      headerAlign: "center",
    },

    {
      text: "Capacity UOM",
      dataField: "capacity_weight_type",
      style: { minWidth: "60px" },
      headerAlign: "center",
    },
    {
      text: "Max Volume",
      dataField: "capacity_volume",
      style: { minWidth: "60px" },
      headerAlign: "center",
    },
    {
      text: "Volume UOM",
      dataField: "capacity_volume_type",
      style: { minWidth: "60px" },
      headerAlign: "center",
    },
    {
      text: "Max Quantity",
      dataField: "capacity_qty",
      style: { minWidth: "60px" },
      headerAlign: "center",
    },
    {
      text: "Quantity UOM",
      dataField: "capacity_qty_type",
      style: { minWidth: "60px" },
      headerAlign: "center",
    },

    {
      text: "Validated By",
      dataField: "validated_by",
      style: { minWidth: "60px" },
      headerAlign: "center",
    },

    {
      text: "status",
      dataField: "status_validate",
      style: { minWidth: "60px" },
      headerAlign: "center",
    },
    {
      text: "Validate",
      dataField: "remark",
      style: { minWidth: "60px" },
      headerAlign: "center",
    },
  ];

  return loading ? (
    <LayoutSplashScreen />
  ) : (
    dataId && (
      <>
        <Card>
          <CardHeader>
            <CardHeaderTitle className="card-title text-white ">
              Master Upload : {dataId.file_type_desc}
            </CardHeaderTitle>

            <CardHeaderToolbar>
              <Button className="primary" onClick={() => history.goBack()}>
                Back To List
              </Button>
            </CardHeaderToolbar>
          </CardHeader>

          <CardBody>
            <>
              <div>
                <Row>
                  <Col xs={12} sm={3} md={6} lg={6}>
                    <RedditTextField
                      required
                      label="File Name"
                      className={classes.margin}
                      variant="filled"
                      id="reddit-input"
                      size="small"
                      fullWidth
                      name="File Name"
                      value={dataId.file_name}
                    />

                    <RedditTextField
                      label="Upload Date"
                      className={classes.margin}
                      variant="filled"
                      id="reddit-input"
                      size="small"
                      fullWidth
                      name="Upload Date"
                      value={formatDate(dataId.uploaded_date)}
                    />
                    <RedditTextField
                      label="Username"
                      className={classes.margin}
                      variant="filled"
                      id="reddit-input"
                      size="small"
                      fullWidth
                      name="Username"
                      value={dataId.username}
                    />
                  </Col>
                  <Col xs={12} sm={3} md={6} lg={6}>
                    <RedditTextField
                      label="Select"
                      className={classes.margin}
                      variant="filled"
                      id="reddit-input"
                      size="small"
                      fullWidth
                      name="party_name"
                      value={dataId.file_type_desc}
                    />
                    <RedditTextField
                      label="Status"
                      className={classes.margin}
                      variant="filled"
                      id="reddit-input"
                      size="small"
                      fullWidth
                      name="Status"
                      value={dataId.status}
                    />
                    {dataId.status === "Uploaded" && (
                      <Row className="mt-6 justify-content-end">
                        <Button variant="primary" onClick={handleSave}>
                          Process File
                        </Button>
                      </Row>
                    )}
                  </Col>
                </Row>
              </div>
              <hr />
              <div>
                {dataId.file_type === "PARTY" && (
                  <BootstrapTable
                    wrapperClasses="table-responsive"
                    classes="table table-head-custom table-vertical-center overflow-hidden rounded table-container mt-5"
                    bootstrap4
                    
                    keyField="Code"
                    data={
                      dataId.data_to_object === null
                        ? []
                        : dataId.data_to_object
                    }
                    columns={columnsParty}
                    // sort={{ dataField: sortField, order: sortOrder }}
                    hover
                    striped
                    headerClasses="header-class"
                  />
                )}
                {dataId.file_type === "LOCATION" && (
                  <BootstrapTable
                    wrapperClasses="table-responsive"
                    classes="table table-head-custom table-vertical-center overflow-hidden rounded table-container mt-5"
                    bootstrap4
                    
                    keyField="Code"
                    data={
                      dataId.data_to_object === null
                        ? []
                        : dataId.data_to_object
                    }
                    columns={columnsLocation}
                    // sort={{ dataField: sortField, order: sortOrder }}
                    hover
                    striped
                    headerClasses="header-class"
                  />
                )}
                {dataId.file_type === "PRODUCTMASTER" && (
                  <BootstrapTable
                    wrapperClasses="table-responsive"
                    classes="table table-head-custom table-vertical-center overflow-hidden rounded table-container mt-5"
                    bootstrap4
                    
                    keyField="Code"
                    data={
                      dataId.data_to_object === null
                        ? []
                        : dataId.data_to_object
                    }
                    columns={columnsProductMaster}
                    // sort={{ dataField: sortField, order: sortOrder }}
                    hover
                    striped
                    headerClasses="header-class"
                  />
                )}

                {dataId.file_type === "MODELMASTER" && (
                  <BootstrapTable
                    wrapperClasses="table-responsive"
                    classes="table table-head-custom table-vertical-center overflow-hidden rounded table-container mt-5"
                    bootstrap4
                    
                    keyField="Code"
                    data={
                      dataId.data_to_object === null
                        ? []
                        : dataId.data_to_object
                    }
                    columns={columnsModelMaster}
                    // sort={{ dataField: sortField, order: sortOrder }}
                    hover
                    striped
                    headerClasses="header-class"
                  />
                )}

                {dataId.file_type === "COLORMASTER" && (
                  <BootstrapTable
                    wrapperClasses="table-responsive"
                    classes="table table-head-custom table-vertical-center overflow-hidden rounded table-container mt-5"
                    bootstrap4
                    
                    keyField="Code"
                    data={
                      dataId.data_to_object === null
                        ? []
                        : dataId.data_to_object
                    }
                    columns={columnsColorMaster}
                    // sort={{ dataField: sortField, order: sortOrder }}
                    hover
                    striped
                    headerClasses="header-class"
                  />
                )}

                {dataId.file_type === "COUNTRY" && (
                  <BootstrapTable
                    wrapperClasses="table-responsive"
                    classes="table table-head-custom table-vertical-center overflow-hidden rounded table-container mt-5"
                    bootstrap4
                    
                    keyField="Code"
                    data={
                      dataId.data_to_object === null
                        ? []
                        : dataId.data_to_object
                    }
                    columns={columnsCountry}
                    // sort={{ dataField: sortField, order: sortOrder }}
                    hover
                    striped
                    headerClasses="header-class"
                  />
                )}
                {dataId.file_type === "LOCATIONMASTER" && (
                  <BootstrapTable
                    wrapperClasses="table-responsive"
                    classes="table table-head-custom table-vertical-center overflow-hidden rounded table-container mt-5"
                    bootstrap4
                    
                    keyField="Code"
                    data={
                      dataId.data_to_object === null
                        ? []
                        : dataId.data_to_object
                    }
                    columns={columnsLocationMaster}
                    // sort={{ dataField: sortField, order: sortOrder }}
                    hover
                    striped
                    headerClasses="header-class"
                  />
                )}
              </div>
            </>
          </CardBody>
        </Card>
      </>
    )
  );
};
